var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 31.7043L20.25 34.7354L15 37.7665L15 31.7043ZM22.75 33.8693C23.4167 34.2542 23.4167 35.2165 22.75 35.6014L14.5 40.3645C13.8333 40.7494 13 40.2683 13 39.4985L13 29.9722C13 29.2024 13.8333 28.7213 14.5 29.1062L17.8889 31.0628C20.6495 25.8161 26.1557 22.2354 32.5 22.2354C41.6127 22.2354 49 29.6227 49 38.7354C49 39.2877 48.5523 39.7354 48 39.7354C47.4477 39.7354 47 39.2877 47 38.7354C47 30.7272 40.5081 24.2354 32.5 24.2354C26.8992 24.2354 22.0382 27.4108 19.6224 32.0636L22.75 33.8693Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.90eebd65.svg";
export { ForwardRef as ReactComponent };